import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '@services/auth';

export const adminPortalRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  const user = authService.getCurrentUser();

  if (user?.type === 'customer') {
    return router.createUrlTree(['/home']);
  }

  if (user && authService.canAccessDashboard()) {
    return true;
  }

  if (user) {
    return true;
  }

  return authService.ensureSessionFor('customer').pipe(
    map((isCustomer) => (isCustomer ? router.createUrlTree(['/home']) : true)),
  );
};
